import { Injectable, EventEmitter } from '@angular/core';
import { PagedSearch, PagedResult } from '../../model/index';
import { UtilService } from '../../util/util.service';
import { LazyLoadEvent } from 'primeng/api';
import { Table as DataTable } from 'primeng/table';
import { IDatagridService } from './idatagrid.service';

@Injectable()
export class DatagridService implements IDatagridService {
  public _utilService: UtilService;

  public lazyLoadEvent: EventEmitter<any>;

  public constructor(utilService: UtilService) {
    this._utilService = utilService;

    this.lazyLoadEvent = new EventEmitter();
  }

  public applyPagingDefaults = (dataGrid: DataTable, params: any): void => {
    //at a min the element must be set like:
    //p-dataTable #dataGridName [lazy]="true" [rows]="15" [value]="pagedResultObject.Result" [totalRecords]="pagedResultObject.TotalCount"

    dataGrid;
    dataGrid.paginator = true;

    if (this._utilService.isNotNullOrUndefined(params.PageSize)) {
      if (this._utilService.isNotNullOrUndefined(dataGrid.rows)) {
        if (dataGrid.rows > 0) {
          params.PageSize = dataGrid.rows;
          //set default rows per page
          dataGrid.rowsPerPageOptions = [];
          dataGrid.rowsPerPageOptions.push(dataGrid.rows);
          dataGrid.rowsPerPageOptions.push(dataGrid.rows * 2);
          dataGrid.rowsPerPageOptions.push(dataGrid.rows * 3);
          dataGrid.rowsPerPageOptions.push(dataGrid.rows * 4);
        }
      }
    }

    dataGrid.onLazyLoad.subscribe((event: LazyLoadEvent) => {
      //get the proposed paging param changes for the given event (paging sorting etc)
      let pagedParam: PagedSearch = this.getPagedSearchFromDataGridEvent(event);

      //emit this new param
      this.lazyLoadEvent.emit(pagedParam);
    });
  };

  public getPagedSearchFromDataGridEvent = (event: LazyLoadEvent): PagedSearch => {
    let pagedParam: PagedSearch = new PagedSearch();

    if (this._utilService.isNotNullOrUndefined(event)) {
      //event.first = First row offset
      //event.rows = Number of rows per page
      //event.sortField = Field name to sort with
      //event.sortOrder = Sort order as number, 1 for asc and -1 for dec
      //filters: FilterMetadata object having field as key and filter value, filter matchMode as value

      if (this._utilService.isNotNullOrUndefined(event.rows)) {
        pagedParam.PageSize = event.rows;
      }

      if (pagedParam.PageSize > 0) {
        pagedParam.PageNumber = (event.first + pagedParam.PageSize) / pagedParam.PageSize;
        pagedParam.PageNumber = Math.floor(pagedParam.PageNumber);
      }

      if (this._utilService.isNotNullOrUndefined(event.sortField) && this._utilService.isNotNullOrUndefined(event.sortOrder)) {
        pagedParam.OrderBy = event.sortField;
        if (event.sortOrder == -1) {
          //desc
          pagedParam.OrderBy += ':desc';
        } else {
          //asc
          pagedParam.OrderBy += ':asc';
        }
      }
    }
    return pagedParam;
  };

  public mapPagedSearchToParams = (pagedSearch: PagedSearch, params: any): any => {
    if (this._utilService.isNotNullOrUndefined(params.OrderBy)) {
      params.OrderBy = pagedSearch.OrderBy;
    }
    if (this._utilService.isNotNullOrUndefined(params.PageNumber)) {
      if (pagedSearch.PageNumber > 0) {
        params.PageNumber = pagedSearch.PageNumber;
      }
    }
    if (this._utilService.isNotNullOrUndefined(params.PageSize)) {
      if (pagedSearch.PageSize > 0) {
        params.PageSize = pagedSearch.PageSize;
      }
    }
    if (this._utilService.isNotNullOrUndefined(params.TotalCount)) {
      if (pagedSearch.TotalCount > 0) {
        params.TotalCount = pagedSearch.TotalCount;
      }
    }
    if (this._utilService.isNotNullOrUndefined(params.TotalPages)) {
      if (pagedSearch.TotalPages > 0) {
        params.TotalPages = pagedSearch.TotalPages;
      }
    }

    return params;
  };

  public mapPagedResultToParams = (pagedResult: PagedResult, params: any): any => {
    if (this._utilService.isNotNullOrUndefined(params.PageNumber)) {
      if (pagedResult.CurrentPageNumber > 0) {
        params.PageNumber = pagedResult.CurrentPageNumber;
      }
    }
    if (this._utilService.isNotNullOrUndefined(params.PageSize)) {
      if (pagedResult.PageSize > 0) {
        params.PageSize = pagedResult.PageSize;
      }
    }
    if (this._utilService.isNotNullOrUndefined(params.TotalCount)) {
      if (pagedResult.TotalCount > 0) {
        params.TotalCount = pagedResult.TotalCount;
      }
    }

    return params;
  };

  //******depreciated use the above methods***/

  public mapDatagridPagingToPagedSearch = (dataGridPagingEvent: LazyLoadEvent, pagedParam: any): any => {
    //NOTE having an *ngIf or equivalent that hides and shows the datagrid
    //will fire a lazy load everytime if hides and shows
    //so DO NOT do that

    if (this._utilService.isNotNullOrUndefined(dataGridPagingEvent)) {
      //event.first = First row offset
      //event.rows = Number of rows per page
      //event.sortField = Field name to sort with
      //event.sortOrder = Sort order as number, 1 for asc and -1 for dec
      //filters: FilterMetadata object having field as key and filter value, filter matchMode as value

      if (this._utilService.isNotNullOrUndefined(dataGridPagingEvent.rows) && dataGridPagingEvent.rows > 0) {
        pagedParam.PageSize = dataGridPagingEvent.rows;
      }

      if (pagedParam.TotalCount <= pagedParam.PageSize) {
        pagedParam.PageNumber = 1;
        pagedParam.TotalPages = 1;
      } else {
        if (pagedParam.PageSize > 0) {
          pagedParam.PageNumber = (dataGridPagingEvent.first + pagedParam.PageSize) / pagedParam.PageSize;
          pagedParam.PageNumber = Math.floor(pagedParam.PageNumber);
          pagedParam.TotalPages = pagedParam.TotalCount / pagedParam.PageSize;
          pagedParam.TotalPages = Math.ceil(pagedParam.TotalPages);
        }
      }

      if (
        this._utilService.isNotNullOrUndefined(dataGridPagingEvent.sortField) &&
        this._utilService.isNotNullOrUndefined(dataGridPagingEvent.sortOrder)
      ) {
        pagedParam.OrderBy = dataGridPagingEvent.sortField;
        if (dataGridPagingEvent.sortOrder == -1) {
          //desc
          pagedParam.OrderBy += ':desc';
        } else {
          //asc
          pagedParam.OrderBy += ':asc';
        }
      }
    }
    return pagedParam;
  };

  public mapPagedResultsToPagedSearch(pagedResult: PagedResult, param: any): void {
    param.PageNumber = pagedResult.CurrentPageNumber;
    param.PageSize = pagedResult.PageSize;
    param.TotalCount = pagedResult.TotalCount;

    param.TotalPages = pagedResult.TotalPages;
    param.PageNumber = pagedResult.CurrentPageNumber;
  }
}
